/* global _mtm */
import React, { Component } from 'react';
import ReactJWPlayer from 'react-jw-player';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import './VideoPlayer.scss';

export class VideoPlayer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loadingState: 'loading'
    };
  }

  render() {
    const {
      className,
      videoURL,
      videoImageURL,
      videoTitle,
      checkTimeStamp,
      jwPlayerScript,
      trackElement
    } = this.props;
    const { loadingState } = this.state;
    const spinnerClasses = classnames({
      spinner: true,
      'spinner-medium': true
    });

    const trackVideoEvent = eventIdentifer => {
      if (trackElement && eventIdentifer && window && window._mtm) {
        _mtm.push({
          event: 'dnuk.conferences.media',
          element: trackElement,
          identifier: eventIdentifer
        });
      }
    };

    return (
      <div className="c-video-player__wrapper">
        {loadingState === 'loading' && <div className={spinnerClasses} />}
        <div
          style={{
            opacity: loadingState === 'loading' ? 0 : 1,
            transition: 'opacity 1s ease-in-out'
          }}>
          <ReactJWPlayer
            customProps={{
              title: videoTitle
            }}
            aspectRatio="16:9"
            className={className}
            playerId="article-video"
            licenseKey="rlCOcEuY9eTvaVLixaHmySPM4m8+AXCfwcsCQgz0yKU="
            playerScript={jwPlayerScript || '/api/script/jwplayer'}
            file={`${videoURL}`}
            image={`${videoImageURL}`}
            onReady={() => this.setState({ loadingState: 'loaded' })}
            onTime={event => checkTimeStamp && checkTimeStamp(event)}
            onPlay={() => trackVideoEvent && trackVideoEvent('play-video')} // initial play of the video
            onPause={() => trackVideoEvent && trackVideoEvent('pause-video')}
            onResume={() => trackVideoEvent && trackVideoEvent('resume-video')}
            onVideoLoad={() => trackVideoEvent && trackVideoEvent('load-video')}
          />
        </div>
      </div>
    );
  }
}

VideoPlayer.defaultProps = {
  videoURL: '',
  videoImageURL: '',
  className: ''
};

VideoPlayer.propTypes = {
  className: PropTypes.string,
  videoURL: PropTypes.string,
  videoImageURL: PropTypes.string,
  videoTitle: PropTypes.string,
  checkTimeStamp: PropTypes.func,
  trackElement: PropTypes.string,
  jwPlayerScript: PropTypes.string
};
